import moment from 'moment'
import { consoleLog } from './Logger'
import { DetailMCC } from './fakeres/Res'
import { isEmpty } from './validation'
import { OwnershipType, AccountType as AccountTypeHome, isMiniFlow } from 'pages/home/data'
import { isSingapore, isPhilippinesFlow, isMalaysia } from 'utils/tenant'

export const getMccDetailFromCode = (list: DetailMCC) => {
  const array = {}

  for (let i = 0; i < list.mccList.length; i++) {
    const catItem = list.mccList[i]
    for (let j = 0; j < catItem.subCategory.length; j++) {
      const subCategory = catItem.subCategory[j]

      for (let k = 0; k < subCategory.merchantCategory.length; k++) {
        const mCat = subCategory.merchantCategory[k]
        array[mCat.mccCode] = {
          categoryType: catItem.categoryType,
          categoryLabel: catItem.label,
          subCategoryType: subCategory.subCategoryType,
          subCategoryLabel: subCategory.label,
          mccCode: mCat.mccCode,
          merchantCategory: mCat.label,
          riskCategory: mCat.riskCategory,
        }
      }
    }
  }
  return array
}

export const BPROOF_SE = 'Shop & Establishment Certificate'
export const BPROOF_GST_AUTO = 'GSTIN'
export const BPROOF_GST_MANUAL = 'GSTIN'
export const BPROOF_TL = 'Trade License'
export const BPROOF_LLP = 'LLP'
export const BPROOF_CIN = 'CIN'

export const SPROOF_SE = 'GSTIN'
export const SPROOF_SNE = 'SnE'
export const SPROOF_TRADE_LICENSE = 'TRADE_LICENSE'
export const SPROOF_UDYAM = 'UDYAM_REGISTRATION'

export const BPROOF_UDHYAM = 'Udyam Registration'

// export const getBusinessProofOptions = (isAutoFetch) => {
//   const businessProofs = []
//   consoleLog('isAutoFetch === ' + isAutoFetch)
//   if (isAutoFetch) {
//     businessProofs.push({ key: 'gstin_auto', value: BPROOF_GST_AUTO })
//   }
//   businessProofs.push({ key: 'gstin_manual', value: BPROOF_GST_MANUAL })
//   businessProofs.push({ key: 'se', value: BPROOF_SE })
//   businessProofs.push({ key: 'tradelicense', value: BPROOF_TL })

//   consoleLog('businessProofs == ' + businessProofs.length)
//   return businessProofs
// }

export const BusinessProofMapping = {
  GSTIN: BPROOF_GST_MANUAL,
  SnE: BPROOF_SE,
  TRADE_LICENSE: BPROOF_TL,
  UDYAM_REGISTRATION: BPROOF_UDHYAM,
}

export enum BusinessProof {
  BPROOF_SE = 'Shop & Establishment Certificate',
  BPROOF_GST_AUTO = 'GSTIN(Auto-fetched)',
  BPROOF_GST_MANUAL = 'GSTIN(Manual entry)',
  BPROOF_TL = 'Trade License',
  BPROOF_CIN = 'CIN',
  BPROOF_LLPIN = 'LLPIN',
  BPROOF_COMPANY = 'Private/Public Limited Firm',
  BPROOF_LLP = 'LLP',
}

export const BusinessProofMappingForStore = () => {
  const proof = []
  proof.push({ key: 'gstin_auto', value: SPROOF_SE, label: SPROOF_SE })
  proof.push({ key: 'udyamAadhar', value: BPROOF_UDHYAM, label: SPROOF_UDYAM })
  if (!isMiniFlow()) {
    proof.push({ key: 'se', value: 'Shop & Establishment Certificate', label: SPROOF_SNE })
    proof.push({ key: 'tradelicense', value: 'Trade License', label: SPROOF_TRADE_LICENSE })
  }
  return proof
}

export const Role = {
  Owner: 1,
  Partner: 2,
  Director: 3,
  Employee: 4,
  Others: 5,
}

export const RoleID = {
  '1': 'Owner',
  '2': 'Partner',
  '3': 'Director',
  '4': 'Employee',
  '5': 'Others',
}

export const RoleArr = [
  {
    key: 'Owner',
    value: 'Owner',
  },
  {
    key: 'Partner',
    value: 'Partner',
  },
  {
    key: 'Director',
    value: 'Director',
  },
  {
    key: 'Employee',
    value: 'Employee',
  },
  {
    key: 'Others',
    value: 'Others',
  },
]

export const isDateValid = (date) => {
  const now = new Date()
  const date1 = moment(now, 'DD-MM-YYYY')
  const date2 = moment(new Date(date), 'DD-MM-YYYY')
  const diff = date2.diff(date1, 'day') // 2seconds
  const year = parseInt(moment(new Date(date), 'DD-MM-YYYY').format('YYYY'))
  consoleLog('isDateValid = diff == ' + diff)
  consoleLog('isDateValid = year == ' + year)
  return diff < 0 && year >= 1900
}

export const isManualVerificationRequired = (type) => {
  if (isEmpty(type)) {
    return false
  }
  if (type === BPROOF_GST_AUTO || type === BPROOF_GST_MANUAL) {
    return false
  }
  return true
}

export const getDocType = (businesProof) => {
  let documentType = ''
  let documentSubType = ''
  if (businesProof === SPROOF_TRADE_LICENSE) {
    documentType = 'BUSINESSLEGALITYPROOF'
    documentSubType = 'TRADELICENSE'
  } else if (businesProof === SPROOF_SNE) {
    documentType = 'BUSINESSLEGALITYPROOF'
    documentSubType = 'SHOPESTABLISHMENTCERTIFICATE'
  } else if (businesProof === SPROOF_SE) {
    documentType = 'BUSINESSLEGALITYPROOF'
    documentSubType = 'GST'
  } else if (businesProof === SPROOF_UDYAM) {
    documentType = 'BUSINESSLEGALITYPROOF'
    documentSubType = 'UDYAMREGISTRATION'
  }
  return { documentType, documentSubType }
}

export enum AccountType {
  SOLE_PROPRIETORSHIP = 'Sole Proprietorship',
  PARTNERSHIP = 'Partnership',
  SDN_BHD = 'Sdn Bhd',
  BHD = 'Bhd',
  RETAIL = 'Retail',
  PETROLEUM = 'Petroleum',
}

export const validOwnershipTypes = [
  'PROPRIETORSHIP',
  'PARTNERSHIP',
  'LIMITED_PARTNERSHIP',
  'COMPANY',
  'SOLE_PROPRIETORSHIP',
  'LIMITED_LIABILITY_PARTNERSHIP',
  'FOREIGN_ENTITY_REGISTRATION',
  'FUND_VEHICLE',
  'CORPORATION',
  'SINGLE_PROPRIETORSHIP',
  'GOCC_LGU_OTHER_GOVERNMENT_AGENCIES',
  'COOPERATIVES',
  'SDN_BHD',
  'BHD',
]

export const getBusinessProofOptions = (isAutoFetch, ownershipType) => {
  const businessProofs = []
  consoleLog('isAutoFetch === ' + isAutoFetch + ', ownershipType = ' + ownershipType)
  if (isAutoFetch) {
    businessProofs.push({ key: 'gstin_auto', value: BusinessProof.BPROOF_GST_AUTO })
  }

  if (ownershipType === BusinessProof.BPROOF_COMPANY) {
    ownershipType = OwnershipType.COMPANY
  }

  switch (ownershipType) {
    case OwnershipType.PROPRIETORSHIP:
      businessProofs.push({ key: 'gstin_manual', value: BusinessProof.BPROOF_GST_MANUAL })
      businessProofs.push({ key: 'se', value: BusinessProof.BPROOF_SE })
      businessProofs.push({ key: 'tradelicense', value: BusinessProof.BPROOF_TL })
      break
    case OwnershipType.FIRM:
      businessProofs.push({ key: 'gstin_manual', value: BusinessProof.BPROOF_GST_MANUAL })
      businessProofs.push({ key: 'llpin', value: BusinessProof.BPROOF_LLPIN })
      break

    case OwnershipType.COMPANY:
    case OwnershipType.PUBLIC_LIMITED_COMPANY:
    case OwnershipType.PRIVATE_LIMITED_COMPANY:
      businessProofs.push({ key: 'cin', value: BusinessProof.BPROOF_CIN })
      break
    case OwnershipType.LLP:
      businessProofs.push({ key: 'llp', value: BusinessProof.BPROOF_LLP })
      break
    case OwnershipType.PARTNERSHIP:
      businessProofs.push({ key: 'gstin_manual', value: BPROOF_GST_MANUAL })
      businessProofs.push({ key: 'se', value: BPROOF_SE })
      businessProofs.push({ key: 'tradelicense', value: BPROOF_TL })
      break
  }
  //  if(ownershipType === OwnershipType.PROPRIETORSHIP || ownershipType === )
  // businessProofs.push({ key: 'gstin_manual', value: BPROOF_GST_MANUAL })
  // businessProofs.push({ key: 'se', value: BPROOF_SE })
  // businessProofs.push({ key: 'tradelicense', value: BPROOF_TL })

  consoleLog('businessProofs == ' + businessProofs.length)
  return businessProofs
}

export const getOwnershipList = (ownershipType) => {
  const ownerShipTypeList = []
  consoleLog('getOwnershipList === ' + ownershipType)
  if (isEmpty(ownershipType) || ownershipType === OwnershipType.PROPRIETORSHIP)
    ownerShipTypeList.push({
      key: OwnershipType.PROPRIETORSHIP,
      value: OwnershipType.PROPRIETORSHIP + '',
    })
  else if (ownershipType === OwnershipType.PARTNERSHIP) {
    ownerShipTypeList.push({
      key: OwnershipType.PARTNERSHIP,
      value: OwnershipType.PARTNERSHIP + '',
    })
    // ownerShipTypeList.push({ key: OwnershipType.LLP, value: OwnershipType.LLP + '' })
  } else if (ownershipType === OwnershipType.LLP) {
    ownerShipTypeList.push({
      key: OwnershipType.PARTNERSHIP,
      value: OwnershipType.PARTNERSHIP + '',
    })
    // ownerShipTypeList.push({ key: OwnershipType.LLP, value: OwnershipType.LLP + '' })
  } else if (ownershipType === OwnershipType.COMPANY) {
    // ownerShipTypeList.push({
    //   key: OwnershipType.COMPANY,
    //   value: 'Private/Public Limited Firm',
    // })
    // ownerShipTypeList.push({
    //   key: OwnershipType.PRIVATE_LIMITED_COMPANY,
    //   value: 'PRIVATE_LIMITED_COMPANY',
    // })
  }
  consoleLog('getOwnershipList == ' + ownerShipTypeList.length)
  return ownerShipTypeList
}

export const getAccountType = () => {
  const accountTypeList = []
  accountTypeList.push({ key: AccountType.RETAIL, value: AccountType.RETAIL })
  accountTypeList.push({ key: AccountType.PETROLEUM, value: AccountType.PETROLEUM })

  return accountTypeList
}

/*
    Allowing only GST and Udyam for 3P Agent Only
*/
export const getBusinesProof = () => {
  const businessProof = []
  businessProof.push({
    key: 'GSTIN',
    value: 'GSTIN',
  })
  businessProof.push({
    key: 'UDYAM_REGISTRATION',
    value: 'Udyam Registration',
  })

  if (!isMiniFlow()) {
    businessProof.push({
      key: 'SnE',
      value: 'Shop & Establishment Certificate',
    })

    businessProof.push({
      key: 'TRADE_LICENSE',
      value: 'Trade License',
    })
  }

  return businessProof
}

export const getBusinesProofFor3PAgent = () => {
  const businessProof = []
  businessProof.push({
    key: 'GSTIN',
    value: 'GSTIN',
  })
  businessProof.push({
    key: 'UDYAM_REGISTRATION',
    value: 'Udyam Registration',
  })

  return businessProof
}

export const getBusinesProofLabel = (type) => {
  return getBusinesProof()?.find((item) => {
    return item?.key === type
  })?.value
}

export const getBusinesProofType = (label) => {
  return getBusinesProof()?.find((item) => {
    return item?.value === label
  })?.key
}

export const getKycSyncType = (type: string) => {
  if (type === SPROOF_SE) return 'GST'
  else if (type === SPROOF_SNE) return 'SE_CERTIFICATE'
  else if (type === SPROOF_TRADE_LICENSE) return SPROOF_TRADE_LICENSE
  else if (type === SPROOF_UDYAM) return 'UDYAM_REGN'
  return type
}

export const AccountTypes = () => {
  const accountTypeList = []

  if (isSingapore() && !isPhilippinesFlow()) {
    accountTypeList.push({ key: 'RETAIL', value: AccountTypeHome.RETAIL })
    accountTypeList.push({ key: 'PETROLEUM', value: AccountTypeHome.PETROLEUM })
    accountTypeList.push({ key: 'ACQUIRER', value: AccountTypeHome.ACQUIRER })
    accountTypeList.push({ key: 'CORPORATE', value: AccountTypeHome.CORPORATE })
    accountTypeList.push({ key: 'VIRTUAL_STORE', value: AccountTypeHome.VIRTUAL_STORE })
    accountTypeList.push({ key: 'PROPRIETORSHIP', value: AccountTypeHome.PROPRIETORSHIP })
    accountTypeList.push({ key: 'PARTNERSHIP', value: AccountTypeHome.PARTNERSHIP })
    accountTypeList.push({ key: 'COMPANY', value: AccountTypeHome.COMPANY })
    accountTypeList.push({ key: 'SOLE_PROPRIETORSHIP', value: AccountTypeHome.SOLE_PROPRIETORSHIP })
    accountTypeList.push({ key: 'LIMITED_PARTNERSHIP', value: AccountTypeHome.LIMITED_PARTNERSHIP })
    accountTypeList.push({ key: 'LIMITED_LIABILITY_PARTNERSHIP', value: AccountTypeHome.LIMITED_LIABILITY_PARTNERSHIP })
    accountTypeList.push({ key: 'FOREIGN_ENTITY_REGISTRATION', value: AccountTypeHome.FOREIGN_ENTITY_REGISTRATION })
    accountTypeList.push({ key: 'FUND_VEHICLE', value: AccountTypeHome.FUND_VEHICLE })
    return accountTypeList
  }

  if (isMalaysia()) {
    accountTypeList.push({ key: 'RETAIL', value: AccountTypeHome.RETAIL })
    accountTypeList.push({ key: 'PETROLEUM', value: AccountTypeHome.PETROLEUM })
    accountTypeList.push({ key: 'ACQUIRER', value: AccountTypeHome.ACQUIRER })
    accountTypeList.push({ key: 'CORPORATE', value: AccountTypeHome.CORPORATE })
    accountTypeList.push({ key: 'VIRTUAL_STORE', value: AccountTypeHome.VIRTUAL_STORE })
    accountTypeList.push({ key: 'PROPRIETORSHIP', value: AccountTypeHome.PROPRIETORSHIP })
    accountTypeList.push({ key: 'PARTNERSHIP', value: AccountTypeHome.PARTNERSHIP })
    accountTypeList.push({ key: 'COMPANY', value: AccountTypeHome.COMPANY })
    accountTypeList.push({ key: 'SOLE_PROPRIETORSHIP', value: AccountTypeHome.SOLE_PROPRIETORSHIP })
    accountTypeList.push({ key: 'LIMITED_PARTNERSHIP', value: AccountTypeHome.LIMITED_PARTNERSHIP })
    accountTypeList.push({ key: 'LIMITED_LIABILITY_PARTNERSHIP', value: AccountTypeHome.LIMITED_LIABILITY_PARTNERSHIP })
    accountTypeList.push({ key: 'FOREIGN_ENTITY_REGISTRATION', value: AccountTypeHome.FOREIGN_ENTITY_REGISTRATION })
    accountTypeList.push({ key: 'FUND_VEHICLE', value: AccountTypeHome.FUND_VEHICLE })
    accountTypeList.push({ key: 'SDN_BHD', value: AccountTypeHome.SDN_BHD })
    accountTypeList.push({ key: 'BHD', value: AccountTypeHome.BHD })
    return accountTypeList
  }

  if (isPhilippinesFlow()) {
    accountTypeList.push({ key: 'RETAIL', value: AccountTypeHome.RETAIL })
    accountTypeList.push({ key: 'PETROLEUM', value: AccountTypeHome.PETROLEUM })
    accountTypeList.push({ key: 'PROPRIETORSHIP', value: AccountTypeHome.PROPRIETORSHIP })
    accountTypeList.push({ key: 'PARTNERSHIP', value: AccountTypeHome.PARTNERSHIP })
    accountTypeList.push({ key: 'CORPORATION', value: AccountTypeHome.CORPORATION })
    accountTypeList.push({ key: 'SINGLE_PROPRIETORSHIP', value: AccountTypeHome.SINGLE_PROPRIETORSHIP })
    accountTypeList.push({ key: 'GOCC_LGU_OTHER_GOVERNMENT_AGENCIES', value: AccountTypeHome.GOCC_LGU_OTHER_GOVERNMENT_AGENCIES })
    accountTypeList.push({ key: 'COOPERATIVES', value: AccountTypeHome.COOPERATIVES })
    return accountTypeList
  }

  accountTypeList.push({ key: 'RETAIL', value: AccountTypeHome.RETAIL })
  if (!isMiniFlow()) {
    accountTypeList.push({ key: 'PETROLEUM', value: AccountTypeHome.PETROLEUM })
  }
  return accountTypeList
}



export const getCreateOppDocumentTypes = (kycDocumentType: string) => {
  let documentSubType = ''
  let documentName = ''
  let documentType = ''

  if (kycDocumentType === SPROOF_TRADE_LICENSE) {
    documentSubType = 'TRADELICENSE'
    documentType = 'BUSINESSLEGALITYPROOF'
    documentName = 'tradelicense'
  } else if (kycDocumentType === SPROOF_SNE) {
    documentSubType = 'SHOPESTABLISHMENTCERTIFICATE'
    documentType = 'BUSINESSLEGALITYPROOF'
    documentName = 'sne'
  } else if (kycDocumentType === SPROOF_UDYAM) {
    documentSubType = 'UDYAMREGISTRATION'
    documentType = 'BUSINESSLEGALITYPROOF'
    documentName = 'udyam'
  } else {
    documentType = 'BUSINESSLEGALITYPROOF'
    documentSubType = 'GST'
    documentName = 'gst'
  }
  return { documentType, documentSubType, documentName }
}
